import React from 'react'
import StudenTab from '../components/student_personal/student_tab/index.jsx'


export const StudentProfilePage  = () => {
  return (
    <div>
      <StudenTab/>
    </div>
  )
}

export default StudentProfilePage 
